import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { Loader2, Trash2 } from "lucide-react";

export const ConfirmDismissDialog = ({
  open,
  onOpenChange,
  title,
  description,
  busy,
  onConfirm,
  confirmTestId,
  cancelTestId,
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="dismiss-confirm-dialog" className="max-w-md">
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={cancelTestId} disabled={busy}>
          Annulla
        </AlertDialogCancel>
        <AlertDialogAction
          data-testid={confirmTestId}
          disabled={busy}
          onClick={(e) => {
            e.preventDefault();
            onConfirm();
          }}
          className="bg-red-600 text-white hover:bg-red-700"
        >
          {busy ? (
            <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />
          ) : (
            <Trash2 className="mr-1.5 h-4 w-4" />
          )}
          Elimina
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
